import { render } from "./ConfirmationCode.vue?vue&type=template&id=18c25aac"
import script from "./ConfirmationCode.vue?vue&type=script&lang=js"
export * from "./ConfirmationCode.vue?vue&type=script&lang=js"

import "./ConfirmationCode.vue?vue&type=style&index=0&id=18c25aac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__